import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import useGetEasyUploadLink from '@hooks/requests/easy-upload-link.get.hook';
import useUpdateEasyUploadLink from '@hooks/requests/easy-upload-link.patch.hook';
export const EasyUploadLinkModalContext = createContext(undefined);
export function EasyUploadLinkModalContextProvider(params) {
    const { data: fetchedEasyUploadLink, loading: easyUploadLinkFetchLoading, error: easyUploadLinkFetchError } = useGetEasyUploadLink(params.subcontractWorkStatusId);
    const { updateEasyUploadLink, data: updatedEasyUploadLink, loading: easyUploadLinkUpdateLoading, error: easyUploadLinkUpdateError } = useUpdateEasyUploadLink(params.subcontractWorkStatusId);
    const [easyUploadLink, setEasyUploadLink] = useState(null);
    const modalDataInitializing = easyUploadLinkFetchLoading;
    const modalInitializationError = easyUploadLinkFetchError;
    const closeModal = useCallback(() => {
        params.onClose();
    }, [params]);
    useEffect(() => {
        if (updatedEasyUploadLink) {
            setEasyUploadLink(updatedEasyUploadLink);
        }
    }, [updatedEasyUploadLink]);
    useEffect(() => {
        if (fetchedEasyUploadLink) {
            setEasyUploadLink(fetchedEasyUploadLink);
        }
    }, [fetchedEasyUploadLink]);
    const contextData = useMemo(() => {
        const value = {
            modalReady: !modalDataInitializing,
            modalError: modalInitializationError !== null && modalInitializationError !== void 0 ? modalInitializationError : null,
            easyUploadLinkUpdateReady: !easyUploadLinkUpdateLoading,
            easyUploadLinkUpdateError: easyUploadLinkUpdateError !== null && easyUploadLinkUpdateError !== void 0 ? easyUploadLinkUpdateError : null,
            easyUploadLink: easyUploadLink !== null && easyUploadLink !== void 0 ? easyUploadLink : null,
            closeModal,
            updateEasyUploadLink
        };
        return value;
    }, [
        easyUploadLink,
        easyUploadLinkUpdateLoading,
        easyUploadLinkUpdateError,
        updateEasyUploadLink,
        modalDataInitializing,
        modalInitializationError,
        closeModal
    ]);
    return (React.createElement(EasyUploadLinkModalContext.Provider, { value: contextData }, params.children));
}
